<template>
  <div class="text-center">
    <p class="text-left text-gray-500">
      Sustainability Score
    </p>
    <div class="mt-5 flex gap-x-3.5">
      <div
        class="relative box-border flex h-14 w-14 flex-none items-center justify-center rounded-full border-[6px] border-neutral-200 font-mono"
      >
        <p class="absolute">
          {{ sustainabilityScore }}
        </p>
        <span
          class="absolute -left-5 -top-5 rotate-0 transition delay-700 ease-[cubic-bezier(.22,.91,.77,.62)]"
          :style="sustainabilityTreeStyle"
        >
          <SustainabilityTree />
        </span>
      </div>
      <div
        class="relative grid w-full shrink content-center items-center bg-stone-100"
      >
        <div
          class="absolute z-20 my-auto h-2.5 bg-[#8BB700] transition-all delay-700 ease-[cubic-bezier(.22,.91,.77,.62)]"
          :style="sustainabilityScoreStyle"
        />
        <span class="absolute -bottom-1 left-0 h-1.5 w-0.5 bg-slate-900" />
        <span
          class="absolute -bottom-1 right-0 h-1.5 w-0.5 bg-slate-900"
        />
        <span
          class="absolute -bottom-6 -left-1 text-xs font-light text-slate-900"
        >0</span>
        <span
          class="absolute -bottom-6 -right-2 text-xs font-light text-slate-900"
        >100</span>
        <div
          class="absolute left-[62%] z-10 h-full w-0.5 border-l border-dashed border-slate-900"
        />
        <span
          class="absolute -top-6 left-[62%] -translate-x-full whitespace-nowrap text-xs font-light text-slate-900"
        >Industry Average: 62</span>
        <div
          class="absolute left-[89%] z-10 h-full w-0.5 border-l border-slate-900"
        />
        <span
          class="absolute -top-6 left-[89%] -translate-x-full whitespace-nowrap text-xs font-light text-slate-900"
        >Target: 89</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SustainabilityScoreCard',

  props: {
    score: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      sustainabilityScore: this.score,
    }
  },

  computed: {
    sustainabilityScoreStyle() {
      return `width: ${this.sustainabilityScore}%;`
    },
    sustainabilityTreeStyle() {
      return `transform: scale(0.${Math.round(this.sustainabilityScore)});`
    },
  },

  watch: {
    score(newScore) {
      this.sustainabilityScore = newScore
    },
  },
}
</script>
